import React, { useState } from "react"
import "./step2-register.scss"
import Button from "../../../shared/components/atoms/button/button"
import { withPrefix } from "gatsby"
import { registerStepDatalayer } from "../../../utils/registerDatalayer"
import { textAndNumberReguex } from "../../../shared/utils/emailRegex"
import Loader from "react-loader-spinner"

let flag = false
const Step2Register = props => {
  const [showToolTip, setShowToolTip] = useState(false)
  const { loadingButton } = props
  if (props.userData) {
    if (props.userData.fullDate === "") {
      window.location.href = withPrefix("/fecha-de-nacimiento")
    }
  } else {
    if (typeof window !== "undefined") {
      window.location.href = withPrefix("/fecha-de-nacimiento")
    }
  }

  return (
    <>
      <form
        onSubmit={props.handleSubmit(() => {
          props.onSubmit()
          registerStepDatalayer({ category: "registro_2", label: "siguiente" })
        })}
      >
        <div className="f-step-register-form">
          <span className="f-step-register-form-error-generic">
            {Object.keys(props.errors).length > 0 &&
              props.errors.nickName?.type !== "nickName-invalid" &&
              "*Debes completar todos los campos"}
          </span>
          <div className="f-step-register-form-item">
            <div>
              <label>NOMBRE</label>
              <input
                onChange={e => {
                  if (e.target.value === " ") {
                    props.setValue("name", "")
                  } else {
                    props.setValue("name", e.target.value.replace(/ {2}/g, " "))
                  }
                }}
                type="text"
                name="name"
                maxLength="60"
                className={
                  props.errors.name
                    ? "f-form-name f-error-value"
                    : "f-form-name"
                }
                autoComplete="off"
                id={"outlined-name"}
                onBlur={e => {
                  props.handleChange(e)
                }}
                ref={props.register({
                  required: true,
                  pattern: /^[A-Za-z\S\u00f1\u00d1][A-Za-z\s\u00f1\u00d1]+[\S]$/,
                })}
              />
              <span className="f-step-register-form-error f-step-register-form-error-label">
                {props.errors.name && props.errors.name.type === "required"
                  ? ""
                  : props.errors.name && "Nombre inválido"}
              </span>
            </div>
            <div>
              <label>APELLIDOS</label>
              <input
                onChange={e => {
                  if (e.target.value === " ") {
                    props.setValue("lastName", "")
                  } else {
                    props.setValue(
                      "lastName",
                      e.target.value.replace(/ {2}/g, " ")
                    )
                  }
                }}
                type="text"
                name="lastName"
                maxLength="60"
                className={
                  props.errors.lastName
                    ? "f-form-lastName f-error-value"
                    : "f-form-lastName"
                }
                autoComplete="off"
                id={"outlined-name"}
                onBlur={e => {
                  props.handleChange(e)
                }}
                ref={props.register({
                  required: true,
                  pattern: /^[A-Za-z\S\u00f1\u00d1][A-Za-z\s\u00f1\u00d1]+[\S]$/,
                })}
              />
              <span className="f-step-register-form-error f-step-register-form-error-label">
                {props.errors.lastName &&
                props.errors.lastName.type === "required"
                  ? ""
                  : props.errors.lastName && "Apellido inválido"}
              </span>
            </div>
          </div>
          <div className="f-step-register-form-item">
            <div>
              <div className="f-step-register-form-item-label-icon">
                <label>¿TIENES USUARIO ÚNICO?</label>
                <span> (Opcional)</span>
                <span
                  className="icon-info"
                  onMouseOver={() => setShowToolTip(true)}
                  onMouseLeave={() => setShowToolTip(false)}
                ></span>
                {showToolTip && (
                  <div className="tooltip">
                    Ingresa aquí el Usuario Único que creaste al registrarte en
                    Nosotras V-App como menor de edad. Así podrás unificar tus
                    cuentas sin perder información.
                  </div>
                )}
              </div>
              <input
                onChange={e => {
                  if (e.target.value === " ") {
                    props.setValue("nickName", "")
                  } else {
                    props.setValue("nickName", e.target.value)
                    props.setValues({
                      ...props.values,
                      ["nickName"]: e.target.value,
                    })
                  }
                }}
                type="text"
                name="nickName"
                maxLength="60"
                className={
                  props.errors.nickName
                    ? "f-form-lastName f-error-value"
                    : "f-form-lastName"
                }
                autoComplete="off"
                id={"outlined-name"}
                onBlur={e => {
                  props.handleChange(e)
                }}
                ref={props.register({
                  pattern: textAndNumberReguex(),
                })}
              />
              <span className="f-step-register-form-error f-step-register-form-error-label">
                {props.errors.nickName?.type === "pattern" &&
                  "Usuario inválido"}
                {props.errors.nickName?.type === "nickName-invalid" &&
                  props.errors.nickName?.message}
              </span>
            </div>
          </div>
          <br />
          <br />
        </div>
        <div className="f-step-register-buttons">
          {loadingButton ? (
            <Loader type="TailSpin" color="#FF409B" height={50} width={50} />
          ) : (
            <Button
              className="f-btn new-primary-pink short f-btn-form-nextStep"
              title="Siguiente"
              type="submit"
            />
          )}
          <Button
            onClick={e => {
              registerStepDatalayer({
                category: "registro_2",
                label: "anterior",
              })
              props.hadleBack && props.hadleBack(e)
            }}
            className="f-btn new-primary-pink--outline short f-btn-form-prevStep"
            title="Anterior"
          />
        </div>
      </form>
    </>
  )
}

export default Step2Register
